var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedirectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79074 0C7.45942 0 7.19074 0.268626 7.19074 0.6C7.19074 0.931368 7.45942 1.2 7.79074 1.2H9.95128L4.97554 6.17574C4.74123 6.41004 4.74123 6.78996 4.97554 7.02426C5.20984 7.25856 5.58976 7.25856 5.82406 7.02426L10.7998 2.04853V4.20902C10.7998 4.54039 11.0684 4.809 11.3998 4.809C11.7312 4.809 11.9998 4.54039 11.9998 4.20902V0.6C11.9998 0.268632 11.7312 0 11.3998 0H7.79074Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 3.60078C1.2 3.26941 1.46863 3.00078 1.8 3.00078H5.59998C5.93136 3.00078 6.19998 2.73215 6.19998 2.40078C6.19998 2.06941 5.93136 1.80078 5.59998 1.80078H1.8C0.80589 1.80078 0 2.60667 0 3.60078V10.2008C0 11.1949 0.80589 12.0008 1.8 12.0008H8.4C9.39414 12.0008 10.2 11.1949 10.2 10.2008V6.75792C10.2 6.42654 9.93138 6.15792 9.6 6.15792C9.26862 6.15792 9 6.42654 9 6.75792V10.2008C9 10.5322 8.73138 10.8008 8.4 10.8008H1.8C1.46863 10.8008 1.2 10.5322 1.2 10.2008V3.60078Z",
    fill: "#7E7E7E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectionIcon);
export default __webpack_public_path__ + "static/media/RedirectionIcon.5e4b1771.svg";
export { ForwardRef as ReactComponent };